import React from 'react'
import { Flex, Modal, Text, TextVariant } from '@mprolab/uikit'
import styled, { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'

import UseAnimations from 'react-useanimations'
import activity from 'react-useanimations/lib/activity'

interface DepositModalProps {
  onDismiss?: () => void
  network: string
}

const StyledText = styled(Text)`
  white-space: pre-wrap;
`

const DepositModal: React.FC<DepositModalProps> = ({ onDismiss, network }) => {
  const { t } = useTranslation()
  const { colors } = useTheme()

  return (
    <Modal {...{ onDismiss }}>
      <Flex
        padding="16px 0 24px 0"
        gap="16px"
        flexDirection="column"
        maxWidth="600px"
        justifyContent="center"
        alignItems="center"
      >
        <UseAnimations animation={activity} strokeColor={colors.purple} size={48} />
        <StyledText textTransform="uppercase" textAlign="center" variant={TextVariant.H5}>
          {t('depositModal.title', { network })}
        </StyledText>
        <StyledText textAlign="center" variant={TextVariant.BODY_DEFAULT}>
          {t('depositModal.description', { network })}
        </StyledText>
      </Flex>
    </Modal>
  )
}

export default DepositModal
